import axios from "axios";
import * as ROUTES from "../../../../constants/routes";
import Helpers from "../../../Helpers";

export default class CategoryAddFunction {
  constructor() {
    this.helpers = new Helpers();
  }

  doCategoryAdd = (catName, catDesc, catCode, catOrder, catIcon) => {
    const token = this.helpers.getCookie("token");
    catDesc = this.helpers.whiteSpaceToStringConverter(catDesc);
    const order = catOrder ? parseInt(catOrder, 10) : null;
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append(
        "req",
        JSON.stringify({ name: catName, description: catDesc, code: catCode, order: order })
      );
      if (catIcon && catIcon[0]) {
        formData.append("icon", catIcon[0]);
      }
      axios
        .post(
          ROUTES.FUNCTIONAL_BASE_URL + "funds-funds/createNewCategory",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };
}
